import { Result, Button, Typography } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { ONBOARDING_PAGE_BACKGROUND } from '../styles/onboardingSurface';

const { Text } = Typography;

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate('/select-plan');
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: ONBOARDING_PAGE_BACKGROUND,
      padding: 20,
    }}>
      <Result
        icon={<CloseCircleOutlined style={{ color: '#faad14' }} />}
        status="warning"
        title="Suscripción Cancelada"
        subTitle={
          <div>
            <Text>
              El proceso de pago fue cancelado. No se realizó ningún cargo.
            </Text>
            <br />
            <Text type="secondary">
              Puedes intentar de nuevo cuando lo desees o continuar usando el periodo de prueba.
            </Text>
          </div>
        }
        extra={[
          <Button
            type="primary"
            key="retry"
            size="large"
            onClick={handleRetry}
            style={{ background: 'var(--color-primary)', borderColor: 'var(--color-primary)' }}
          >
            Seleccionar Otro Plan
          </Button>,
          <Button
            key="home"
            size="large"
            onClick={handleGoHome}
          >
            Continuar con Prueba Gratuita
          </Button>,
        ]}
        style={{
          background: 'var(--bg-primary)',
          padding: '48px 32px',
          borderRadius: 16,
          boxShadow: '0 4px 24px var(--shadow-color)',
        }}
      />
    </div>
  );
};

export default SubscriptionCancel;
